import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Modules`}</p>
    <dl>
      <dt><a href="#module_Buildpack/Utilities">Buildpack/Utilities</a></dt>
      <dd></dd>
    </dl>
    <p>{`Typedefs`}</p>
    <dl>
      <dt><a href="#EnvVarDefinitions">EnvVarDefinitions</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Defines the global settings of the project as a list of typed environment variables.
Includes a set of changes made to the environment variables in recent versions, to aid with migration and upgrades.`}</p>
        <p><inlineCode parentName="p">{`EnvVarDefinitions`}</inlineCode>{` are used by `}<a parentName="p" {...{
            "href": "https://developer.adobe.com/commerce/pwa-studio/api/buildpack/cli/load-environment-file/"
          }}><inlineCode parentName="a">{`loadEnvironment()`}</inlineCode></a>{`
to validate the currently defined values in the environment.`}</p>
        <p><inlineCode parentName="p">{`EnvVarDefinitions`}</inlineCode>{` are also used by `}<a parentName="p" {...{
            "href": "https://developer.adobe.com/commerce/pwa-studio/api/buildpack/cli/create-environment-file/"
          }}><inlineCode parentName="a">{`createDotEnvFile()`}</inlineCode></a>{`
to generate an extensively commented `}<inlineCode parentName="p">{`.env`}</inlineCode>{` file for a project.`}</p>
      </dd>
      <dt><a href="#EnvVarDefsSection">EnvVarDefsSection</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`A list of related definitions concerning a particular functional area.`}</p>
        <p>{`All defined variable names under a particular functional area should have the same prefix, to help namespace and organize configuration.
For instance, all variable names in the "Custom local origin" section begin with `}<inlineCode parentName="p">{`CUSTOM_ORIGIN_`}</inlineCode>{`.`}</p>
      </dd>
      <dt><a href="#EnvVarDefinition">EnvVarDefinition</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`A definition of an environment variable that will be used somewhere else in the project, in the backend and/or the frontend.`}</p>
        <p>{`Must define a name, type and description. Optionally, may define a `}<inlineCode parentName="p">{`default`}</inlineCode>{` which is set implicitly, an `}<inlineCode parentName="p">{`example`}</inlineCode>{` for documentation,
and/or an array of `}<inlineCode parentName="p">{`choices`}</inlineCode>{` to limit the valid values.`}</p>
        <p>{`The recommended way to access the current environment values in build scripts and interceptors is through the
`}<a parentName="p" {...{
            "href": "https://developer.adobe.com/commerce/pwa-studio/guides/general-concepts/configuration/#configuration-object"
          }}>{`Configuration object`}</a>{`
object returned by `}<a parentName="p" {...{
            "href": "https://developer.adobe.com/commerce/pwa-studio/api/buildpack/cli/load-environment-file/"
          }}><inlineCode parentName="a">{`loadEnvironment()`}</inlineCode></a>{`.`}</p>
        <p><strong parentName="p">{`Note:`}</strong>{` Any build environment will have hundreds of environment variables `}<em parentName="p">{`set`}</em>{`, most of which are unrelated to the build process.
Any environment variable during the build is accessible via `}<inlineCode parentName="p">{`process.env`}</inlineCode>{` in NodeJS.
However, only the variables defined by `}<inlineCode parentName="p">{`EnvVarDefinition`}</inlineCode>{` entries will be available in the frontend, via the `}<a parentName="p" {...{
            "href": "https://webpack.js.org/plugins/environment-plugin/"
          }}>{`Webpack EnvironmentPlugin`}</a>{`.`}</p>
      </dd>
      <dt><a href="#EnvVarDefsChange">EnvVarDefsChange</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Describes a recent change to a particular environment variable.
Can indicate that the environment variable was `}<em parentName="p">{`removed`}</em>{` or `}<em parentName="p">{`renamed`}</em>{`.
Change objects can log informative warnings to developers to help with migration.
They may also be used to make `}<inlineCode parentName="p">{`loadEnvironment()`}</inlineCode>{` support the legacy name of a renamed variable.`}</p>
      </dd>
    </dl>
    <p>{`Defines the global settings of the project as a list of typed environment variables.
Includes a set of changes made to the environment variables in recent versions, to aid with migration and upgrades.`}</p>
    <p><inlineCode parentName="p">{`EnvVarDefinitions`}</inlineCode>{` are used by `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/pwa-studio/api/buildpack/cli/load-environment-file/"
      }}><inlineCode parentName="a">{`loadEnvironment()`}</inlineCode></a>{`
to validate the currently defined values in the environment.`}</p>
    <p><inlineCode parentName="p">{`EnvVarDefinitions`}</inlineCode>{` are also used by `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/pwa-studio/api/buildpack/cli/create-environment-file/"
      }}><inlineCode parentName="a">{`createDotEnvFile()`}</inlineCode></a>{`
to generate an extensively commented `}<inlineCode parentName="p">{`.env`}</inlineCode>{` file for a project.`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`sections`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#EnvVarDefsSection"
            }}><inlineCode parentName="a">{`Array.<EnvVarDefsSection>`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`List of sections, or sub-lists of definitions grouped under a title.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`changes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#EnvVarDefsChange"
            }}><inlineCode parentName="a">{`Array.<EnvVarDefsChange>`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`List of changes, or objects describing a recent change to a definition.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`A list of related definitions concerning a particular functional area.`}</p>
    <p>{`All defined variable names under a particular functional area should have the same prefix, to help namespace and organize configuration.
For instance, all variable names in the "Custom local origin" section begin with `}<inlineCode parentName="p">{`CUSTOM_ORIGIN_`}</inlineCode>{`.`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Title of the section, describing the functional area of the included variables.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`variables`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#EnvVarDefinition"
            }}><inlineCode parentName="a">{`Array.<EnvVarDefinition>`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`List of variable definitions.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`A definition of an environment variable that will be used somewhere else in the project, in the backend and/or the frontend.`}</p>
    <p>{`Must define a name, type and description. Optionally, may define a `}<inlineCode parentName="p">{`default`}</inlineCode>{` which is set implicitly, an `}<inlineCode parentName="p">{`example`}</inlineCode>{` for documentation,
and/or an array of `}<inlineCode parentName="p">{`choices`}</inlineCode>{` to limit the valid values.`}</p>
    <p>{`The recommended way to access the current environment values in build scripts and interceptors is through the
`}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/pwa-studio/guides/general-concepts/configuration/#configuration-object"
      }}>{`Configuration object`}</a>{`
object returned by `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/pwa-studio/api/buildpack/cli/load-environment-file/"
      }}><inlineCode parentName="a">{`loadEnvironment()`}</inlineCode></a>{`.`}</p>
    <p><strong parentName="p">{`Note:`}</strong>{` Any build environment will have hundreds of environment variables `}<em parentName="p">{`set`}</em>{`, most of which are unrelated to the build process.
Any environment variable during the build is accessible via `}<inlineCode parentName="p">{`process.env`}</inlineCode>{` in NodeJS.
However, only the variables defined by `}<inlineCode parentName="p">{`EnvVarDefinition`}</inlineCode>{` entries will be available in the frontend, via the `}<a parentName="p" {...{
        "href": "https://webpack.js.org/plugins/environment-plugin/"
      }}>{`Webpack EnvironmentPlugin`}</a>{`.`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Name of the environment variable. Must be in SCREAMING_SNAKE_CASE and contain only alphanumeric characters.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Type of the environment variable. Can be any type supported by the `}<a parentName="td" {...{
              "href": "https://www.npmjs.com/package/envalid#validator-types"
            }}>{`envalid`}</a>{` library.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`desc`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Human-readable description of what the environment variable does.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[choices]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An array of acceptable answers. All values in the array must be of the type specified in `}<inlineCode parentName="td">{`type`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`default`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Default value if the variable is not set in the environment.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`example`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Example value which will be displayed in inline documentation in the `}<inlineCode parentName="td">{`.env`}</inlineCode>{` file.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Describes a recent change to a particular environment variable.
Can indicate that the environment variable was `}<em parentName="p">{`removed`}</em>{` or `}<em parentName="p">{`renamed`}</em>{`.
Change objects can log informative warnings to developers to help with migration.
They may also be used to make `}<inlineCode parentName="p">{`loadEnvironment()`}</inlineCode>{` support the legacy name of a renamed variable.`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`removed`}</inlineCode>{` or `}<inlineCode parentName="td">{`renamed`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Name of the EnvVarDefinition that was recently changed. If the change is a rename, this must be the `}<em parentName="td">{`old`}</em>{` variable name.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`reason`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Reason given for the change. Will be logged as a warning.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`dateChanged`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Date that the change was released, in ISO-8601 format (or any format parseable by JavaScript `}<inlineCode parentName="td">{`Date()`}</inlineCode>{`.)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[warnForDays]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Number of days after `}<inlineCode parentName="td">{`dateChanged`}</inlineCode>{` to log a warning if the removed or renamed variable is still set in the environment. Default, and maximum, is 180 days.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[update]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`New name of the variable. Required when the change is a rename.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[supportLegacy]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If the change is a rename, set this to `}<inlineCode parentName="td">{`true`}</inlineCode>{` to support the old name (while logging a warning). If the old name is set and the new name is not, `}<inlineCode parentName="td">{`loadEnvironment`}</inlineCode>{` will set the new variable name to the value of the old one.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Source Code`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/pwa-buildpack/lib/Utilities/getEnvVarDefinitions.js"
      }}>{`pwa-studio/packages/pwa-buildpack/lib/Utilities/getEnvVarDefinitions.js`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      